import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaWallet, FaQuestionCircle, FaCog } from "react-icons/fa"; // Import icons
import "../styles/MobileWidgets.css"; // Import styles

const MobileWidget = () => {
  return (
    <div className="mobile-widgets">
      <Link to="/dashboard" className="widget-btn">
        <FaHome />
        <span>Home</span>
      </Link>
      <Link to="/wallet" className="widget-btn">
        <FaWallet />
        <span>Wallet</span>
      </Link>
      <Link to="/help" className="widget-btn">
        <FaQuestionCircle />
        <span>Support</span>
      </Link>
      <Link to="/settings" className="widget-btn">
        <FaCog />
        <span>Settings</span>
      </Link>
    </div>
  );
};

export default MobileWidget;
